import _ from 'lodash'
import { Component } from 'react'
import PropTypes from 'prop-types'

class TokenManager extends Component {
    constructor(props) {
        super(props)

        // Expose the commands to dev console
        window.setToken = this.setToken
        window.setTokens = this.setTokens
    }

    shouldComponentUpdate() {
        return false
    }

    // This function is not used by the backend, it is only used by us
    // This is because the backend needs an refresh token to test against when on test servers
    // To make sure noone can access test servers they are not allowed to have access to
    setToken = (serverId) => {
        try {
            // Get the name of the current server,
            // or substitude undefined with "server"
            const finalServerId = serverId != null ? serverId : this.props.activeServer || 'server'

            // Get the list of users for the given server
            const tokens = this.props.tokens[finalServerId]

            // If we have users in the list, get the first user and answer
            // with their refresh token
            if (tokens !== undefined && Object.keys(tokens).length > 0) {
                const userId = Object.keys(tokens)[0]

                // Get first user in object
                const userTokens = tokens[userId]

                if (userTokens != null && userTokens.refresh !== undefined) {
                    // Fire off the command to set the token
                    this.props.setToken(finalServerId, userTokens.refresh)
                    return
                } else if (userTokens == null) {
                    console.info(`No token was available, as user object for ${userId} is null`)
                    return
                } else if (userTokens.refresh == null) {
                    console.info(
                        `No token was available, as user refresh string for ${userId} is null`,
                    )
                    return
                }
            }
            console.info(`No token was available for ${finalServerId}`)
        } catch (error) {
            console.info(
                `Encountered error while running setToken (${serverId || 'no server selected'}): ${
                    error.message
                }`,
            )
        }
    }

    setTokens = () => {
        try {
            // Validation that data is available to set tokens
            // Required are servers & users
            if (this.props.serverIds.length === 0) {
                // We have no servers, fail the condition. Create an entry in the logs and return.
                console.info('No servers were available for setTokens')
                return
            } else if (_.size(this.props.tokens) === 0) {
                // We have no users, failure condition. Create an entry in the logs and return.
                console.info('No users were available for setTokens')
                return
            }

            // We have both servers and users
            // lets find a token for every server and report it
            this.props.serverIds.forEach((serverId) => {
                if (_.size(this.props.tokens[serverId]) > 0) {
                    // Server has one or more accounts pinned
                    this.setToken(serverId)
                }
            })
        } catch (error) {
            console.info(`Encountered an error while running setTokens: ${error.message}`)
        }
    }

    render() {
        return null
    }
}

TokenManager.propTypes = {
    activeServer: PropTypes.string,
    serverIds: PropTypes.arrayOf(PropTypes.string),
    tokens: PropTypes.shape({
        key: PropTypes.string, // serverId
        value: PropTypes.shape({
            key: PropTypes.string, // userId
            value: PropTypes.shape({
                refresh: PropTypes.string,
            }),
        }),
    }),
    setToken: PropTypes.func,
}

export default TokenManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/TokenManager/component.js